import React, { useState, useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./payment.css";
import { addReqToAdmin } from "app/services/paymentService";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import {
  RenderDateInput,
  RenderSelectInput,
  RenderTextArea,
  RenderTextInput,
} from "app/common/renderInput";

import MerchantAutocomplete from "../Merchant/MerchantAutocomplete";
import { getBankList } from "app/services/bankService";
import { Breadcrumb } from "@gull";

const requisitionSchema = Yup.object().shape({
  amount: Yup.number()
    .required("Please enter amount")
    .min(1, "Amount should be greater than 0"),
  bankId: Yup.string().required("Please enter payment through"),
  transferMethod: Yup.string().required("Please select payment type"),
  referenceNo: Yup.string()
    .min(6, "Reference must be at least 6 characters")
    .required("Please enter reference number"),
  transactionDetails: Yup.string().optional(),
  requestDate: Yup.string().required("Please enter request Date"),
  memId: Yup.string().required("Please enter introducer dist"),
  pgType: Yup.string().required("Please select payment Type"),
});

const MerchantAddReq = () => {
  const [state, setState] = useState({
    requestDate: "",
    amount: "",
    bankId: "",
    transactionDetails: "",
    transferMethod: "NEFT",
    pgType: "",
    memId: "",
    bankCharges: 0,
    referenceNo: "",
    bankList: [],
    paymentTypeList: [
      { value: "NEFT", label: "NEFT" },
      { value: "UPI", label: "UPI" },
      { value: "RTGS", label: "RTGS" },
      { value: "ONLINE", label: "ONLINE" },
    ],
    pgOptions: [
      { value: "NORMAL", label: "NORMAL" },
      { value: "CREDIT", label: "CREDIT" },
    ],
  });

  useEffect(() => {
    loadBankLists();
  }, []);

  const loadBankLists = async () => {
    const response = await getBankList();
    const bankData = response.data;
    const bankList = bankData.map((x, i) => {
      return {
        value: x.id,
        label: x.bankName + " - " + x.accountNumber,
      };
    });

    setState((prevState) => ({
      ...prevState,
      bankList,
    }));
  };

  const requisitionHandler = async (values, { resetForm }) => {
    const formattedValues = {
      memId: values.memId,
      requestDate: values.requestDate,
      amount: values.amount,
      bankId: values.bankId,
      transactionDetails: values.transactionDetails,
      transferMethod: values.transferMethod,
      pgType: values.pgType,
      bankCharges: 0,
      referenceNo: values.referenceNo,
    };

    const res = await addReqToAdmin(formattedValues);
    res
      ? NotificationManager.success("Requisition done successfully")
      : NotificationManager.danger("Requisition Failed");

    setState((prevState) => ({
      ...prevState,
      memId: "",
      pgType: "",
    }));
    resetForm({ values: "" });
  };

  return (
    <div>
      <Helmet>
        <title>Merchant Add Requisition</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Merchant Add Requisition" }]} />
      <div>
        <Card>
          <Card.Body>
            <Formik
              initialValues={state}
              validationSchema={requisitionSchema}
              onSubmit={requisitionHandler}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Row className="mb-3 mt-3">
                    <Col>
                      <div className="w-100">
                        <label> Merchant List </label>
                        <span className="text-danger"> * </span>
                        <MerchantAutocomplete
                          setFieldValue={setFieldValue}
                          memId={state.memId}
                          handleChangeOptions={(memId) => {
                            setFieldValue("memId", memId);
                            setState((prevState) => ({
                              ...prevState,
                              memId,
                            }));
                          }}
                          name="memId"
                          value={values.memId}
                        />
                        {!values.memId ? (
                          <small className="text-danger">{errors.memId}</small>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                    <Col>
                      <RenderTextInput
                        type="text"
                        name="amount"
                        display="Amount"
                        placeholder="Amount"
                        value={values.amount}
                        error={errors.amount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.amount}
                        required
                      />
                    </Col>
                    <Col>
                      <RenderSelectInput
                        name="bankId"
                        display="Payment Through"
                        placeholder="Payment Through"
                        value={values.bankId}
                        error={errors.bankId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.bankId}
                        items={state.bankList}
                        required
                      />
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col>
                      <RenderSelectInput
                        name="transferMethod"
                        display="Payment Type"
                        placeholder="Payment Through"
                        value={values.transferMethod}
                        error={errors.transferMethod}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.transferMethod}
                        items={state.paymentTypeList}
                        required
                      />
                    </Col>
                    <Col>
                      <RenderTextInput
                        type="text"
                        name="referenceNo"
                        display="Reference No"
                        placeholder="Reference No"
                        value={values.referenceNo}
                        error={errors.referenceNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.referenceNo}
                        required
                      />
                    </Col>
                    <Col>
                      <RenderDateInput
                        type="date"
                        name="requestDate"
                        display="Request Date"
                        onBlur={handleBlur}
                        value={values.requestDate}
                        onChange={handleChange}
                        touched={touched.requestDate}
                        error={errors.requestDate}
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    {/* <Col>
                      <RenderSelectInput
                        name="pgType"
                        display="Payment Type"
                        placeholder="Payment Type"
                        value={values.pgType}
                        error={errors.pgType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.pgType}
                        items={state.pgOptions}
                        required
                      />
                    </Col> */}
                    <Col>
                      <RenderTextArea
                        type="text"
                        name="transactionDetails"
                        display="Remarks (if any)"
                        placeholder="transactionDetails"
                        value={values.transactionDetails}
                        error={errors.transactionDetails}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.transactionDetails}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mt-2">
                      <button type="submit" className="btn btn-primary">
                        Submit Requisition
                      </button>
                    </Col>
                  </Row>
                </form>
              )}
            </Formik>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default MerchantAddReq;
